// directives/scrollbarAuto.js
export default {
  // 指令挂载时调用
  mounted(el, binding) {
    // 1. 获取滚动容器（默认是指令绑定的元素，若为 el-table 则取其内部滚动容器）
    const scrollContainer =
      el.classList.contains('el-table') || el.classList.contains('el-scrollbar')
        ? el.querySelector('.el-scrollbar__wrap')
        : el;
    if (!scrollContainer) return;
    // 2. 配置默认延迟时间（默认 1500ms，支持通过指令参数自定义）
    const delay = binding.value?.delay || 1500;

    // 3. 滚动定时器（用于延迟隐藏）
    let scrollTimer = null;

    // 4. 滚动事件处理函数
    const handleScroll = () => {
      // 滚动时添加显示类
      el.classList.add('scrollbar-auto-target-visible');

      // 清除定时器，重新计时
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        el.classList.remove('scrollbar-auto-target-visible');
      }, delay);
    };

    // 5. 绑定滚动事件
    scrollContainer.addEventListener('scroll', handleScroll);

    // 6. 保存事件和容器到元素上，便于卸载时清理
    el._scrollbarAuto = {
      scrollContainer,
      handleScroll
    };
  },

  // 指令卸载时调用（清理事件监听）
  unmounted(el) {
    const { scrollContainer, handleScroll } = el._scrollbarAuto || {};
    if (scrollContainer && handleScroll) {
      scrollContainer.removeEventListener('scroll', handleScroll);
    }
  }
};
